interface PersonAvatarProps {
    width?: number;
    height?: number;
    color?: string;
}

const PersonAvatar: React.FC<PersonAvatarProps> = ({
    width = '75%',
    height = '100%',
    color = '#fff',
}) => {
    return (
        <svg
            width={width}
            height={height}
            style={{ margin: 'auto', display: 'flex' }}
            focusable="false"
            viewBox="0 0 24 24"
            aria-hidden="true"
        >
            <path
                fill={color}
                d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
            />
        </svg>
    );
};

export default PersonAvatar;
